import React, { useEffect } from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getAppointmentHistory } from "../../Redux/Slice/AppointmentHistory";

const AppointmentsPage = () => {
  const dispatch = useDispatch();
  const { items } = useSelector((state) => state.appointmentHistory);
  const appointments = items?.data || [];

  useEffect(() => {
    dispatch(getAppointmentHistory());
  }, [dispatch]);

  return (
    <Box sx={{ padding: "2rem" }}>
      <Typography variant="h6" gutterBottom>
        My Appointments
      </Typography>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        Below is a summary of all your past and upcoming appointments.
      </Typography>

      <Box mt={3}>
        {appointments.length === 0 ? (
          <Typography color="text.secondary" sx={{ mt: 2 }}>
            No appointments found.
          </Typography>
        ) : (
          appointments.map((appt) => (
            <Paper
              key={appt.appointmentId}
              elevation={2}
              sx={{
                p: 2,
                mb: 2,
                borderLeft: `6px solid ${
                  appt.status === "BookedByPatient"
                    ? "#1976d2"
                    : appt.status === "Cancelled"
                    ? "gray"
                    : "green"
                }`,
                backgroundColor: "#fafafa",
              }}
            >
              <Typography variant="subtitle1" fontWeight="bold">
                {appt.doctorName}{" "}
                <span style={{ fontWeight: "normal" }}>
                  ({appt.specialityName})
                </span>
              </Typography>
              <Typography>
                <strong>Appointment For:</strong> {appt.patientName}
              </Typography>
              <Typography variant="body2">
                Date: {appt.appointmentDate} | Time: {appt.appointmentTime}
              </Typography>
              {appt.mrdNo && (
                <Typography variant="body2">MRD No: {appt.mrdNo}</Typography>
              )}
              {appt.visitType && (
                <Typography variant="body2">
                  Visit Type: {appt.visitType}
                </Typography>
              )}
              <Typography
                variant="body2"
                sx={{
                  color:
                    appt.status === "BookedByPatient"
                      ? "#1976d2"
                      : appt.status === "Cancelled"
                      ? "gray"
                      : "green",
                  mt: 0.5,
                }}
              >
                Status:{" "}
                {appt.status === "BookedByPatient" ? "Booked" : appt.status}
              </Typography>
            </Paper>
          ))
        )}
      </Box>
    </Box>
  );
};

export default AppointmentsPage;
